import axios from "axios";
import { MainUrl } from "../constants";

const API_URL = `${MainUrl}/approve_dep`;

export const GetApprove = async (token, startDate, endDate) => {
  try {
    const bodyRequest = {
      start_date: startDate,
      end_date: endDate,
    };
    const response = await axios.post(`${API_URL}/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(response, 888);
    return response.data;
  } catch (error) {
    console.log(error, 999);
    return error.response.data;
  }
};

export const Approve = async (
  token,
  startDate,
  endDate,
  statusId,
  comment,
  templateShifts,
  history = [],
) => {
  try {
    const bodyRequest = {
      start_date: startDate,
      end_date: endDate,
      status_id: statusId,
      comment: comment,
      template_shifts: templateShifts,
      history,
    };
    const response = await axios.post(`${API_URL}/approve/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const GetRestaurantsByDate = async (token, date) => {
  try {
    const response = await axios.get(`${API_URL}/restaurants/?date=${date}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const GetByNotApproved = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/by_not_approved/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const GetById = async (token, id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};
